import React__default from 'react';
import '../../../core/enums/GameSpecificTypes.js';
import '../../../core/enums/MaxPayoutDataTypes.js';
import '../../../core/enums/Chat.js';
import '../../../core/enums/GameModes.js';
import '../../../core/enums/IconTypes.js';
import '../../../core/enums/BetStatus.js';
import '../../../core/enums/PopupTypes.js';
import '../../../core/enums/ApiVersion.js';
import '../../../core/enums/RoundStatus.js';
import { FreeBetsStatus } from '../../../core/enums/FreeBetsStatus.js';
import '../../../core/enums/SocketEvents.js';
import { TranslationKeys } from '../../../core/enums/TranslationKeys.js';
import '../../../core/enums/TimeoutMaxValue.js';
import '../../../core/enums/ApiServiceTypes.js';
import '../../../core/enums/EnvironmentTypes.js';
import '../../../core/enums/DefaultQueryValues.js';
import '../../../core/enums/FreeBetWinningType.js';
import '../../../core/enums/DefaultQueryParams.js';
import '../../../core/enums/BetHistoryFilterTypes.js';
import '../../../core/enums/GameThemeTypes.js';
import '../../../core/enums/RequestStatus.js';
import '../../../core/enums/FetchDefaultPaths.js';
import '../../../core/enums/ResponseCodes.js';
import '../../../../loadingStore-df941e1d.js';
import '../../../core/store/chatStore.js';
import '../../../core/store/wageringStore.js';
import '../../../core/store/roundInfoStore.js';
import '../../../core/store/userCountStore.js';
import '../../../core/store/gameResultStore.js';
import '../../../core/store/resultHashStore.js';
import '../../../core/store/userWinBetsStore.js';
import '../../../core/store/notificationStore.js';
import '../../../core/store/selectedResultInfoStore.js';
import '../../../core/services/liveConnection/types.js';
import 'axios';
import '../../../core/services/sound/types.js';
import '../../../core/services/sound/SoundService.js';
import '../../../core/services/sound/defaultSounds.js';
import '../../../core/services/api/types.js';
import '../../../core/services/ApiServices.js';
import '../../../../momentFormat-14fce7b4.js';
import '../../../core/polyfill.js';
import '../../../../tslib.es6-14c74580.js';
import 'mobx';
import '@microsoft/signalr';
import '../../../core/classes/httpResponse/index.js';
import '../../../core/helpers/environmentBuilder.js';
import '../../../core/enums/BogLineGameConfig.js';
import '../../../core/helpers/parseQuery.js';
import '../../../core/services/api/BaseApiService.js';
import '../../../core/enums/StatisticsSortingTypes.js';
import '../../../../table-line/t_types/enums/BetResponseCode.js';
import '../../../../table-line/t_types/enums/BetErrorMessages.js';
import '../../../../table-line/t_types/enums/NotificationByResponseCode.js';
import '../../../../table-line/t_types/enums/FreeChipTypes.js';
import '../../../../table-line/t_types/enums/PopupTypes.js';
import '../../../core/helpers/formatDate.js';
import '../../../core/helpers/isMobile.js';
import '../../../core/helpers/updateHalfBets.js';
import '../../../core/enums/bogGameNames.js';
import 'howler';
import '../../../../_commonjsHelpers-1a7a244d.js';

var FreeBetInfo = function (_a) {
    var t = _a.t, infoData = _a.infoData, selectFreeBet = _a.selectFreeBet, selectedFreeBetId = _a.selectedFreeBetId;
    return (React__default.createElement("div", { className: 'info-wrap' },
        React__default.createElement("div", { className: 'info' },
            React__default.createElement("div", { className: 'info-top' },
                React__default.createElement("p", { className: 'free-bet-info-status' }, infoData.status === FreeBetsStatus.Expired
                    ? t(TranslationKeys.Expired)
                    : infoData.remainingCount &&
                        (infoData.status === FreeBetsStatus.Accepted || infoData.status === FreeBetsStatus.Pending)
                        ? t(TranslationKeys.InProcess)
                        : t(TranslationKeys.Finished)),
                React__default.createElement("div", { className: 'free-bet-info-content' },
                    React__default.createElement("div", { className: 'free-bet-info-content-row' },
                        infoData.maxPayout && (React__default.createElement("div", { className: 'free-bet-info-content-row-text-wr' },
                            React__default.createElement("span", { className: 'free-bet-info-content-row-text' }, t(TranslationKeys.MaxPayout)),
                            ":",
                            React__default.createElement("span", { className: 'free-bet-info-content-row-count' },
                                " ",
                                infoData.maxPayout))),
                        React__default.createElement("div", { className: 'free-bet-info-content-row-text-wr' },
                            React__default.createElement("span", { className: 'free-bet-info-content-row-text' }, t(TranslationKeys.TotalWinByNow)),
                            ":",
                            React__default.createElement("span", { className: 'free-bet-info-content-row-count' },
                                " ",
                                infoData.totalWin)),
                        React__default.createElement("div", { className: 'free-bet-info-content-row-text-wr' },
                            React__default.createElement("span", { className: 'free-bet-info-content-row-text' }, t(TranslationKeys.ReceiveDate)),
                            ":",
                            React__default.createElement("span", { className: 'free-bet-info-content-row-count' },
                                " ",
                                infoData.receiveDate)),
                        React__default.createElement("div", { className: 'free-bet-info-content-row-text-wr' },
                            React__default.createElement("span", { className: 'free-bet-info-content-row-text' }, t(TranslationKeys.ExpirationDate)),
                            ":",
                            React__default.createElement("span", { className: 'free-bet-info-content-row-count' },
                                " ",
                                infoData.expireDateFreeBet))))),
            React__default.createElement("div", { className: 'info-bottom' },
                React__default.createElement("div", { className: 'free-bet-info-wr-bottom-inner' },
                    React__default.createElement("p", { className: 'free-bet-info-wr-bottom-inner-txt' },
                        infoData.count - infoData.remainingCount,
                        "/",
                        infoData.count)),
                React__default.createElement("div", { className: 'free-bet-info-wr-bottom-inner' }, infoData.status !== FreeBetsStatus.Finished &&
                    infoData.status !== FreeBetsStatus.Expired &&
                    !!infoData.remainingCount && (React__default.createElement(React__default.Fragment, null,
                    React__default.createElement("p", { className: 'free-bet-info-wr-bottom-inner-txt' }, t(TranslationKeys.FreeBet)),
                    React__default.createElement("div", { className: 'free-bet-info-wr-switch' },
                        React__default.createElement("label", { className: 'switch' },
                            React__default.createElement("input", { type: 'checkbox', checked: selectedFreeBetId === infoData.id, onChange: function () { return selectFreeBet(infoData); } }),
                            React__default.createElement("span", { className: 'slider round' }))))))))));
};

export { FreeBetInfo };
